<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/duxKDe/tc-custom/1.png?1685327173648?1709061531092" alt="This image is the cover for the book If Toucan, You Can Too"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If Toucan, You Can Too
      </h1>
      <p class="bookDescription body article font2">
        <p>Little Toucan has so many things that he must do but he would much prefer to play instead! Just like most children, he finds that his chores are sometimes a little difficult, but with your help, he is sure you will both succeed. Will Toucan and YOU overcome your difficulties and make Mum and Dad so very proud? You'll have to see for yourself!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Bowron
      </h2>
      
      <p class="authorDescription body article">Simon Bowron is an author of colourful children's picture books who likes to bring a flare of adventure, excitement and laughter to his young readers whilst providing an educational feel to his stories for children who may encounter difficulties in general day-to-day tasks. Simon enjoys creating stories that instil the magical feeling children need to feel, which will make them want to read over and over.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f43f76e8